import { Tooltip } from 'appkit-react';

import MenuTooltip from './MenuTooltip';

const CustomTooltip = props => (
    <div className="menu-icon">
        <Tooltip
            content={MenuTooltip(props)}
            trigger="click"
            refClassName="a-account-info"
            className="a-account-options"
            clickToClose
            tooltipTheme="light"
            style={{ zIndex: 100, width: '150px' }}
        >
            <span className="appkiticon icon-vertical-more-fill a-font-16 a-text-orange" aria-hidden="true" style={{ cursor: 'pointer' }} />
        </Tooltip>
    </div>
);

export default CustomTooltip;
